<div class="grid padding-md">
  <div>action button</div>
  <app-action-button
    [label]="'ADD TO CART'"
    [color]="'primary'"
  ></app-action-button>
  <div>action button disabled</div>
  <app-action-button
    [label]="'ADD TO CART'"
    [color]="'primary'"
    [disabled]="true"
  ></app-action-button>
  <div>action button outlined</div>
  <app-action-button
    [label]="'ADD TO CART'"
    [color]="'primary'"
    [isOutlined]="true"
  ></app-action-button>

  <div>day selector</div>
  <app-day-selector></app-day-selector>

  <div>food category list</div>
  <app-food-category-list></app-food-category-list>

  <div>product card</div>
  <app-product-card></app-product-card>

  <div>quantity selector</div>
  <app-quantity-selector
    [min]="0"
    [max]="10"
    [initial]="1"
    [disabled]="false"
    (valueChanged)="({})"
  ></app-quantity-selector>
</div>
